import { apiClient } from '@/api/client';

export interface SubscribeInput {
  email: string;
  name?: string;
  language?: string;
}

export interface SubscribeResponse {
  id: string;
  email: string;
}

export const newsletterService = {
  subscribe(input: SubscribeInput): Promise<SubscribeResponse> {
    return apiClient.post<SubscribeResponse>('/newsletter/subscribe', input);
  },

  unsubscribe(email: string): Promise<void> {
    return apiClient.post<void>('/newsletter/unsubscribe', { email });
  },
};
